// @ts-nocheck

import memoize from 'memoize-state';

import { getBetslipFromProps } from './common';

export const headerSelector = memoize((state, props) => {
  const { nickname } = props;
  const betslip = getBetslipFromProps(state, props);
  const { validationDate, type } = betslip;

  return {
    type,
    validationDate,
    nickname: nickname || state.user.nickname,
  };
});
